import { RightOutlined } from "@ant-design/icons";
import {
    Row,
    Col,
    Button,
    Form,
    Input,
    Select,
    Radio,
    Space,
} from "antd";
import React, { useEffect, useState } from "react";
import tdsSectionService from "../../../api/tdssection.service";
import { EDIT_MODE, SUCCESS_STATUS } from "../../../utility/Constants";
import CustomMessage from "../../common/CustomMessage";
import commonUtility from "../../../utility/Utils";

const { Option } = Select;

const TdsSectionEntry = ({ data, onDrawerClose, onRefreshList }) => {
    // console.log(data) 
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");

    const [formDefaultValues, setFormDefaultValues] = useState({
        tdsId: data.tdsId,
        tds_desc: data.tds_desc,
        tds_rate: data.tds_rate,
        is_active: data.is_active || 'Y',
        mode: data.mode
    });

    const [mode, setMode] = useState(data.mode);


    const [form] = Form.useForm();


    const onTdsSectionSave = async (values) => {
        try {
            const data = { formdata: values };
            console.log(data);
            
            const resdata = await tdsSectionService.save(data);
            setIsFormResponse(true);
            setFormResponseStatus(resdata.response_status);
            setFormResponseMessage(resdata.response_msg);
            
            if (onRefreshList) {
                onRefreshList();
            }
        } catch (error) {
            console.error("Error saving TDS Section:", error);
            setIsFormResponse(true);
            setFormResponseStatus("error");
            setFormResponseMessage("Failed to save TDS Section. Please try again.");
            
            if (onRefreshList) {
                onRefreshList();
            }
        }
    };


    const hideResponseMessage = () => {
        setIsFormResponse(false);
        if (mode == "ADD") {
            form.resetFields();
            form.setFieldsValue({
                tdsId: formDefaultValues.tdsId,
                mode: data.mode
            })
        }
    }


    useEffect(() => {


        mode == EDIT_MODE ?

            form.setFieldsValue({
                tdsId: formDefaultValues.tdsId,
                tds_desc: formDefaultValues.tds_desc,
                tds_rate: formDefaultValues.tds_rate,
                is_active: formDefaultValues.is_active,
                mode: data.mode
            })
            :
            form.setFieldsValue({
                tdsId: 0,
                tds_desc: '',
                tds_rate: '',
                is_active: 'Y',
                mode: data.mode
            });


        form.setFieldsValue(formDefaultValues)

    }, [form]);

    return (
        <div>
            <div className="form-input-style">
                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onTdsSectionSave}
                            autoComplete="off"
                        >
                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={12}>
                                    <Form.Item name="tds_desc" label="TDS Description" rules={[
                                        {
                                            required: true,
                                            message: 'TDS Description is required',
                                        },
                                    ]}>
                                        <Input placeholder="TDS Description" />
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" xs={24} xl={6}>
                                    <Form.Item name="tds_rate" label="TDS Rate (%)" rules={[
                                        {
                                            required: true,
                                            message: 'TDS Rate is required',
                                        },
                                        {
                                            pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
                                            message: 'Please enter a valid number (up to 2 decimal places)',
                                        },
                                        {
                                            validator: (_, value) => {
                                                if (!value) return Promise.resolve();
                                                const num = parseFloat(value);
                                                if (num < 0 || num > 100) {
                                                    return Promise.reject(new Error('TDS Rate must be between 0 and 100'));
                                                }
                                                return Promise.resolve();
                                            },
                                        },
                                    ]}>
                                        <Input 
                                            placeholder="Enter TDS Rate" 
                                            onKeyPress={(e) => {
                                                if (!/[0-9.]/.test(e.key) && e.key !== 'Backspace') {
                                                    e.preventDefault();
                                                }
                                            }}
                                            maxLength={6}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={6}>
                                    <Form.Item name="is_active" label="Active">
                                        <Radio.Group
                                            defaultValue="Y"
                                            style={{ width: "100%" }}
                                            optionType="button"
                                            buttonStyle="solid"
                                        >
                                            <Radio.Button value="Y">Yes</Radio.Button>
                                            <Radio.Button value="N">No</Radio.Button>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>

                                <Form.Item name="tdsId" label="tdsId" hidden={true}>
                                    <Input type="text" />
                                </Form.Item>
                                <Form.Item name="mode" label="mode" hidden={true}>
                                    <Input type="text" />
                                </Form.Item>



                                <Col xs={24} xl={12}>
                                    <Form.Item name="" label=" ">
                                        <Space>

                                            <Button className="custom-button-green" htmlType="submit">
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                {
                    isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
                }
            </div>
        </div>
    );
}

export default TdsSectionEntry